import {ChartAnalysisRq, ChartAnalysisRs} from '../types';
import texts from '../componenets/AnalysisPanel/texts';
import {basicPOST} from '../../../services/rest/llm/generalAI';

export enum AnalysisType {
    EXECUTIVE = 'Executive',
    COMPARATIVE = 'Comparative',
    STATISTICAL = 'Statistical'
}

export const fetchAnalysis = async (data: ChartAnalysisRq): Promise<ChartAnalysisRs> => {
    try {
        return await basicPOST<ChartAnalysisRs>('analyzeChart', data);
    } catch (error) {
        console.error('Error:', error);
        throw error; // rethrow if you want the caller to handle it
    }
};

export const getDefaultAnalysisError = (): ChartAnalysisRs => {
    return {
        analysisContent: '',
        error: texts.errorMessage
    };
};
